const topicTags = [
  { label: '明星绯闻', count: '3.2万', hot: true },
  { label: '网红翻车', count: '2.8万', hot: true },
  { label: '综艺争议', count: '1.9万', hot: true },
  { label: '娱乐圈黑幕', count: '1.6万', hot: false },
  { label: '恋爱实锤', count: '1.5万', hot: false },
  { label: '婚变传闻', count: '1.3万', hot: false },
  { label: '代言风波', count: '9800', hot: false },
  { label: '选秀黑料', count: '8700', hot: false },
  { label: '资本博弈', count: '7600', hot: false },
  { label: '海外爆料', count: '6500', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-hashtag text-[10px]"></i>
            热门话题
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            大家都在搜的 <span className="font-heading italic text-accent-400">爆料关键词</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            点击任意话题标签，快速浏览相关爆料内容合集
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#topics"
              className={`group relative inline-flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-accent-500 text-background-950 font-bold text-sm md:text-base hover:bg-accent-400'
                  : 'bg-transparent border border-foreground-200/20 text-foreground-300 text-xs md:text-sm hover:border-accent-500/40 hover:text-accent-400'
              }`}
            >
              {tag.hot && <i className="ri-fire-fill text-xs"></i>}
              <span>{tag.label}</span>
              <span
                className={`text-[10px] ${
                  tag.hot
                    ? 'bg-background-950/20 text-background-950 px-1.5 py-0.5 rounded-full'
                    : 'text-foreground-600'
                }`}
              >
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}